import { Box, SectionHelper } from "@wix/design-system";
import React from "react";

const OauthNotConnected = () => {
  return (
    <Box marginBottom={2}>
      <SectionHelper size="small" fullWidth appearance="warning" title="Request to Use API Key Instead of OAuth">
        It seems we aren't able to connect your Faire account using Oauth. Please use the API key method instead.
      </SectionHelper>
    </Box>
  );
};

export default OauthNotConnected;
